import initMap from '../middleware/yandex/map';
import SDEKmap from '../middleware/sdek/map';

initAllMaps();

export function initAllMaps() {
  // const map = document.querySelector('#map');
  // const isMapInPopup = (map !== null && map.closest('.modal') !== null);
  //
  // if (isMapInPopup) {
  //   document.querySelectorAll('[data-init-yamap]').forEach((button) => {
  //     button.addEventListener('click', () => {
  //       // initMap();
  //     }, { once: true });
  //   });
  // } else {
  //   // initMap();
  // }

  initMap();

  document.querySelectorAll('[data-cdek-init]').forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(() => {
        SDEKmap();
      }, 300);
    }, { once: true });
  });

  // window.SDEKmap = SDEKmap;
}
